import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import './style.scss';
import getWeather from '../../fetch';
import { changeCity } from "../../actions";


class Select extends Component {
    cityList = this.props.state.cityList;
    state = {
        cityName: ''
    };

    handleChange = (eventKey) => {
        this.props.changeCity(eventKey);
        this.props.loadWeather(eventKey);
    };
    getCityName = (citySelected) => {
        this.cityList.forEach(city => {
            if (city.id === citySelected) {
                this.setState({...this.state, cityName: city.name})
            }
        })
    };

    componentWillMount() {
        this.props.loadWeather(this.props.selected);
        this.getCityName(this.props.selected);

    }
    componentWillReceiveProps(props) {
        this.getCityName(props.selected)
    }

    render() {
        return ( 
            <div className="select-wrapper pl-3 pr-3">
                <DropdownButton
                    title={this.state.cityName}
                >
                    {
                        this.cityList.map(city => {
                            return (
                                <Dropdown.Item eventKey={city.id} key={city.id} onSelect={this.handleChange}>
                                    {city.name}
                                </Dropdown.Item>
                            )
                        })
                    }
                </DropdownButton>
            </div>
        );
    }
}

export default connect(
    state => ({
        state: state.select,
        selected: state.select.selectedCity
    }),
    dispatch => ({
        changeCity: (value) => {
            dispatch(changeCity(value))
        },
        loadWeather: (cityId) => {
            dispatch(getWeather({cityId}))
        }
    })
)(Select);